import React from 'react'
import PropTypes from 'prop-types'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import HrLine from 'components/_new/layout/HrLine/HrLine'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import InviteForm from 'components/_new/InviteFriendBlock//InviteForm/InviteForm'
import ShareButton from 'components/_new/buttons/ShareButton/ShareButton'

import messages from '../messages'
import s from './ExceptMobile.scss'


const shareButtons = [ 'facebook', 'sms', 'gmail', 'link' ]

const ExceptMobile = ({ page }) => (
  <div className={s.wrapper}>
    <div className={s.container}>
      <WidthContainer>
        <div className={s.content}>
          <Text
            message={messages.title}
            size="48-56"
            color="white"
            semibold
            html
          />
          <Box pt="48">
            <InviteForm page={page} />
          </Box>
          <Box pt="24">
            <HrLine color="white" lineColor="white" or />
          </Box>
          <Box pt="12" className={s.buttonsContainer}>
            {
              shareButtons.map((type) => (
                <ShareButton
                  key={type}
                  page={page}
                  type={type}
                  rounded
                />
              ))
            }
          </Box>
        </div>
      </WidthContainer>
    </div>
  </div>
)

ExceptMobile.propTypes = {
  page: PropTypes.string.isRequired,
}


export default ExceptMobile
